<template>
  <div id="app" :class="[`layout-${$route.meta.layout}`, `lang-${$store.state.locale}`]">
    <div class="service-worker-update" v-if="$store.state.serviceWorkerUpdated">
      内容有更新, 请刷新页面
      <span @click="refresh">刷新</span>
    </div>
    <component :is="layout"></component>
  </div>
</template>

<script>
import { iPath } from '@/utils/i18n'
import Website from '@/layouts/Website'
import WebsiteNoFooter from '@/layouts/WebsiteNoFooter'
import Noop from '@/layouts/Noop'
const Dashboard = () => import('@/layouts/Dashboard' /* webpackChunkName: 'dashboard' */)
export default {
  name: 'app',
  provide: {
    iPath
  },
  computed: {
    layout() {
      switch (this.$route.meta.layout) {
        case 'websiteNoFooter':
          return WebsiteNoFooter
        case 'website':
          return Website
        case 'dashboard':
          return Dashboard
        default:
          return Noop
      }
    }
  },
  methods: {
    refresh() {
      location.reload()
    }
  }
}
</script>
<style lang="scss">
.service-worker-update {
  line-height: 80px;
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  z-index: 100;
  span {
    float: right;
    margin-right: 30px;
    cursor: pointer;
  }
}
</style>
